/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: refactor
 * @LastEditTime: 2026-03-25
 */
import React, { useCallback, useEffect, useRef, useState } from 'react'

import {
  useAppSelector,
  useAppDispatch,
  useVip,
  useSensorsRole
} from '../../../../app/hooks'
import {
  setEditorGeoItemList,
  setEditorWatermark
} from '../../../../actions/watermark'
import PresetItem from './PresetItem'
import enterpriseDialog from '../../../../images/editor/enterprise.png'
import sensors from '../../../../utils/sensors'
import ContactUS from '../../../components/ContactUS'
import { CloseCircleFilled, PlusCircleFilled } from '@ant-design/icons'

interface PresetContentProps {
  index: number
  onBunchAddClick: () => void
  clickEvent: (clickItem: string) => void
}

const PresetContent: React.FC<PresetContentProps> = (props) => {
  const { index, clickEvent, onBunchAddClick } = props
  const itemsWrapperRef = useRef<HTMLDivElement>(null)
  const dispatch = useAppDispatch()
  const watermark = useAppSelector((state) => state.editor.watermark)
  const config = useAppSelector((state) => state.main.config)
  const itemCnt = useAppSelector((state) => state.group.itemCnt)
  const itemLimit = parseInt(
    itemCnt || config?.normal_group_option_limit || 1000
  )
  const geoItemsList = useAppSelector((state) => state.editor.geoItemsList)
  const { isVip } = useVip()
  const sensorsRole = useSensorsRole()
  const presetItems = watermark?.items?.[index]?.contentEdit?.itemsList || []
  const itemsCountRef = useRef(presetItems.length)
  const exceed = presetItems.length >= itemLimit
  const onChange = (newWatermark) => dispatch(setEditorWatermark(newWatermark))

  const [showEnterpriseDialog, setShowEnterpriseDialog] = useState(false)

  const onAddItem = useCallback(() => {
    if (exceed) {
      //企业级会员限制弹窗
      setShowEnterpriseDialog(true)
      sensors.track('web_get_action_pop_watermark_item_pay', {
        actionType: 'showPop',
        isGroupVIP: isVip,
        role: sensorsRole
      })
      return
    }
    const newItemsList = [...presetItems, '']
    const newItems = watermark.items.map((it, idx) =>
      idx === index
        ? {
            ...it,
            contentEdit: {
              ...it.contentEdit,
              itemsList: newItemsList
            }
          }
        : it
    )
    onChange({ ...watermark, items: newItems })
    clickEvent('addOption')
  }, [watermark, presetItems, exceed])

  useEffect(() => {
    //新增条目后，滚动到最后一条
    if (presetItems.length > itemsCountRef.current) {
      if (itemsWrapperRef.current && itemsWrapperRef.current.lastChild) {
        ;(itemsWrapperRef.current.lastChild as HTMLElement).scrollIntoView({
          behavior: 'smooth'
        })
      }
    }
    itemsCountRef.current = presetItems.length
  }, [presetItems])

  return (
    <div className="preset-wrapper">
      <div className="preset-title-wrapper ant-form-item-label">
        <label>选项列表：</label>
        <div>
          <button
            style={{ marginRight: '9px' }}
            onClick={onAddItem}
            // disabled={exceed}
          >
            <PlusCircleFilled />
            添加选项
            {/* {!isVip && (
              <span>
                （{presetItems.length}/{itemLimit}）
              </span>
            )} */}
          </button>
          <button onClick={onBunchAddClick}>
            <PlusCircleFilled />
            批量添加
          </button>
        </div>
      </div>
      <div className="preset-items-wrapper" ref={itemsWrapperRef}>
        {presetItems.map((contentItem, contentItemIndex) => (
          <PresetItem
            key={contentItemIndex}
            index={index}
            contentItemIndex={contentItemIndex}
            contentItem={contentItem}
          />
        ))}
      </div>
      {showEnterpriseDialog && (
        <div className="enterprise-dialog-wrapper">
          <CloseCircleFilled
            className="close-btn"
            onClick={() => setShowEnterpriseDialog(false)}
          />
          <ContactUS
            fromPage="预设选项不限制数量"
            track={() => {
              sensors.track('web_get_action_pop_watermark_item_pay', {
                actionType: 'clickContactUs',
                isGroupVIP: isVip,
                role: sensorsRole
              })
            }}
          >
            <img className="enterprise-dialog-img" src={enterpriseDialog} />
          </ContactUS>
        </div>
      )}
    </div>
  )
}

export default PresetContent
